module.exports = __webpack_public_path__ + "static/img/ph03.3848270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/ph03.jpg
// module id = D2kL
// module chunks = 0